import { numberToPrettyString } from '@cian/utils';
import { CURRENCY_TYPE_SYMBOLS, SQUARE_SYMBOLS } from '../../../constants/symbols';
import { INewbuilding } from '../../../types/newbuilding';

export const getPriceSquareFrom = (newbuilding: INewbuilding): string | undefined => {
  const { minPriceSquareRur } = newbuilding;

  if (!minPriceSquareRur) {
    return undefined;
  }

  const formattedMinPrice = numberToPrettyString(+minPriceSquareRur).replace(/\s/g, '\xA0');

  return `от\xA0${formattedMinPrice}\xA0${CURRENCY_TYPE_SYMBOLS.Rur}/${SQUARE_SYMBOLS.SquareMeter}`;
};
